import React from 'react';
import { FormControl, InputLabel } from '@material-ui/core';
import MaterialInput from '@material-ui/core/Input';
import useStyles from './styles';
import { useId } from '../../hooks';

type Props = {
  className?: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

const Input = ({ className, label, value, onChange, disabled }: Props) => {
  const classes = useStyles();

  const inputId = useId('form-input-');

  return (
    <div>

      <FormControl
        fullWidth
        className={className}
      >
        <InputLabel
          htmlFor={inputId}
          classes={{
            root: classes.labelRoot,
            focused: classes.focused,
          }}
        >
          {label}
        </InputLabel>
        <MaterialInput
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          value={value}
          classes={{
            input: classes.input,
            underline: classes.inputUnderline,
            focused: classes.focused,
            disabled: classes.disabled,
          }}
        />
      </FormControl>
    </div>
  );
};

export default Input;
